<template>
  <div class="ecommerce_product_select_category">
    <!-- <template v-if="!isAppend">
      <DefaultCategory
        v-model="currentCategory"
        :stat="stat"
        @onChangeCategory="onChangeCategory"
      ></DefaultCategory>
    </template> -->

    <template v-for="(category, index) in categorylist">
      <v-btn
        small
        class="ma-1"
        :color="currentCategory != category.slug ? 'grey' : 'primary'"
        depressed
        :outline="currentCategory != category.slug"
        :key="'category_' + index"
        @click="onChangeCategory(category.slug)"
        >{{ category.title }}</v-btn
      >
    </template>

    <template v-if="isAppend">
      <DefaultCategory
        v-model="currentCategory"
        :stat="stat"
        @onChangeCategory="onChangeCategory"
      ></DefaultCategory>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DefaultCategory from './DefaultCategory.vue'

export default {
  props: {
    value: [String, Number],
    categories: Array,
    stat: {
      default: {
        all: 0,
        soldout: 0,
        sales: 0
      },
      type: Object
    },
    isAppend: {
      default: false
    }
  },
  components: {
    DefaultCategory
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  data: function () {
    return {
      categorylist: this.categories,
      currentCategory: this.value
    }
  },
  mounted() {},
  methods: {
    onChangeCategory: function (index) {
      let vm = this
      vm.currentCategory = index
      vm.$emit('input', vm.currentCategory)
      vm.$emit('onChangeCategory')
    }
  },
  watch: {
    value: function () {
      this.currentCategory = this.value
    },
    categories: function () {
      this.categorylist = this.categories
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/FilterCategoryThailandpostmart.vue